import _classCallCheck from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
export var createMediaRecorderConstructor = function createMediaRecorderConstructor(createNativeMediaRecorder, createNotSupportedError, createWebAudioMediaRecorder, createWebmPcmMediaRecorder, encoderRegexes, eventTargetConstructor, nativeMediaRecorderConstructor) {
  return /*#__PURE__*/function (_eventTargetConstruct) {
    _inherits(MediaRecorder, _eventTargetConstruct);

    function MediaRecorder(stream) {
      var _this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, MediaRecorder);

      var mimeType = options.mimeType;

      if (nativeMediaRecorderConstructor !== null && ( // Bug #10: Safari does not yet implement the isTypeSupported() method.
      mimeType === undefined || nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported(mimeType))) {
        var internalMediaRecorder = createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaRecorder).call(this, internalMediaRecorder));
        _this._internalMediaRecorder = internalMediaRecorder;
      } else if (mimeType !== undefined && encoderRegexes.some(function (regex) {
        return regex.test(mimeType);
      })) {
        _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaRecorder).call(this)); // Bug #10: Safari does not yet implement the isTypeSupported() method.

        if (nativeMediaRecorderConstructor !== null && nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported('audio/webm;codecs=pcm')) {
          _this._internalMediaRecorder = createWebmPcmMediaRecorder(_assertThisInitialized(_assertThisInitialized(_this)), nativeMediaRecorderConstructor, stream, mimeType);
        } else {
          _this._internalMediaRecorder = createWebAudioMediaRecorder(_assertThisInitialized(_assertThisInitialized(_this)), stream, mimeType);
        }
      } else {
        // This is creating a native MediaRecorder just to provoke it to throw an error.
        if (nativeMediaRecorderConstructor !== null) {
          createNativeMediaRecorder(nativeMediaRecorderConstructor, stream, options);
        }

        throw createNotSupportedError();
      }

      _this._ondataavailable = null;
      _this._onerror = null;
      _this._onpause = null;
      _this._onresume = null;
      _this._onstart = null;
      _this._onstop = null;
      return _possibleConstructorReturn(_this);
    }

    _createClass(MediaRecorder, [{
      key: "pause",
      value: function pause() {
        return this._internalMediaRecorder.pause();
      }
    }, {
      key: "resume",
      value: function resume() {
        return this._internalMediaRecorder.resume();
      }
    }, {
      key: "start",
      value: function start(timeslice) {
        return this._internalMediaRecorder.start(timeslice);
      }
    }, {
      key: "stop",
      value: function stop() {
        return this._internalMediaRecorder.stop();
      }
    }, {
      key: "mimeType",
      get: function get() {
        return this._internalMediaRecorder.mimeType;
      }
    }, {
      key: "ondataavailable",
      get: function get() {
        return this._ondataavailable === null ? this._ondataavailable : this._ondataavailable[0];
      },
      set: function set(value) {
        if (this._ondataavailable !== null) {
          this.removeEventListener('dataavailable', this._ondataavailable[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('dataavailable', boundListener);
          this._ondataavailable = [value, boundListener];
        } else {
          this._ondataavailable = null;
        }
      }
    }, {
      key: "onerror",
      get: function get() {
        return this._onerror === null ? this._onerror : this._onerror[0];
      },
      set: function set(value) {
        if (this._onerror !== null) {
          this.removeEventListener('error', this._onerror[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('error', boundListener);
          this._onerror = [value, boundListener];
        } else {
          this._onerror = null;
        }
      }
    }, {
      key: "onpause",
      get: function get() {
        return this._onpause === null ? this._onpause : this._onpause[0];
      },
      set: function set(value) {
        if (this._onpause !== null) {
          this.removeEventListener('pause', this._onpause[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('pause', boundListener);
          this._onpause = [value, boundListener];
        } else {
          this._onpause = null;
        }
      }
    }, {
      key: "onresume",
      get: function get() {
        return this._onresume === null ? this._onresume : this._onresume[0];
      },
      set: function set(value) {
        if (this._onresume !== null) {
          this.removeEventListener('resume', this._onresume[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('resume', boundListener);
          this._onresume = [value, boundListener];
        } else {
          this._onresume = null;
        }
      }
    }, {
      key: "onstart",
      get: function get() {
        return this._onstart === null ? this._onstart : this._onstart[0];
      },
      set: function set(value) {
        if (this._onstart !== null) {
          this.removeEventListener('start', this._onstart[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('start', boundListener);
          this._onstart = [value, boundListener];
        } else {
          this._onstart = null;
        }
      }
    }, {
      key: "onstop",
      get: function get() {
        return this._onstop === null ? this._onstop : this._onstop[0];
      },
      set: function set(value) {
        if (this._onstop !== null) {
          this.removeEventListener('stop', this._onstop[1]);
        }

        if (typeof value === 'function') {
          var boundListener = value.bind(this);
          this.addEventListener('stop', boundListener);
          this._onstop = [value, boundListener];
        } else {
          this._onstop = null;
        }
      }
    }, {
      key: "state",
      get: function get() {
        return this._internalMediaRecorder.state;
      }
    }], [{
      key: "isTypeSupported",
      value: function isTypeSupported(mimeType) {
        return nativeMediaRecorderConstructor !== null && // Bug #10: Safari does not yet implement the isTypeSupported() method.
        nativeMediaRecorderConstructor.isTypeSupported !== undefined && nativeMediaRecorderConstructor.isTypeSupported(mimeType) || encoderRegexes.some(function (regex) {
          return regex.test(mimeType);
        });
      }
    }]);

    return MediaRecorder;
  }(eventTargetConstructor);
};